module.exports = __webpack_public_path__ + "img/members.b59c21c1.svg";